import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    statesListUS: null,
    addressTypes: null,
    timeZones: null,
    officeTypes: null,
    phoneNumberTypes: null,
    emailTypes: null,
    mlsProviders: null,
    territoryTypes: null,
    mlsProviderStatuses: null,
    lookupTypeTransactionFeeTypes: null,
    lookupTypeMiscellaneousFeeTypes: null,
    lookupTypeBasedOnTypes: null,
    lookupTypeFeeCategories: null,
    lookupTypePercentOfTypes: null,
    lookupTypeFrequencyTypes: null,
    lookupTypeProductStatuses: null,
    lookupTypeProductTemplateTypes: null,
    lookupTypeFranchiseStaff: null,
    lookupTypesFeePerTypes: null,
    lastState: null,
    lastScope: null
};

const utilityReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.UTILITY_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.UTILITY_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.UTILITY_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default utilityReducer;